import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportProjectTimeReportByUser_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportProjectTimeReportByUser extends Report<ReportProjectTimeReportByUser_Settings> {

    static reportName   : string = "Work Item & User"

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_PROJECT_WORK_ITEM_REPORT_BY_USER
        super(data);

        this.icon         = "isvg-time-work-item-user"
        this.description  = "Displays reported hours for each work item by user, providing a detailed breakdown of who logged time on which tasks and meetings."

        this.settings     = new ReportProjectTimeReportByUser_Settings(data.settings)
    }

    static initFromSavedView(savedView: SavedView): ReportProjectTimeReportByUser {
        return new ReportProjectTimeReportByUser(savedView.toReportConfig());
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportProjectTimeReportByUser_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

    applyProjectScope(projectId: ID) {
        super.applyProjectScope(projectId)

        this.settings.projectId = projectId
    }

    save(){
        console.log("Not implemented")
    }
}
